import { render, staticRenderFns } from "./FcTabSwitcher.vue?vue&type=template&id=38da4f93&scoped=true"
import script from "./FcTabSwitcher.vue?vue&type=script&lang=js"
export * from "./FcTabSwitcher.vue?vue&type=script&lang=js"
import style0 from "./FcTabSwitcher.vue?vue&type=style&index=0&id=38da4f93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38da4f93",
  null
  
)

export default component.exports